/* eslint-disable react/no-unused-state */
import PropTypes from 'prop-types';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Checkbox from '@material-ui/core/Checkbox';
import { TFunction, withTranslation } from 'react-i18next';
import { colors } from '../../../constants/colors';
import { insuranceFormSubmission } from '../../../actions/insurance';
import { receiveUserProfileForNewBooking } from '../../../actions/newBooking';
import { profileFormSubmission } from '../../../actions/profile';
import { showModal } from '../../../actions/runtime';
import { BookingProfileStatus, TYPE_INSURANCE, TYPE_SELF } from '../../../constants/index';
import { analyticsTrackEvent } from '../../../core/analytics';
import {
  BOOKING_WIDGET_BOOK_FAIL,
  BOOKING_WIDGET_ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME,
  BOOKING_WIDGET_MOBILE_CLICK_CONTINUE_BUTTON_SECOND_FORM,
  BOOKING_WIDGET_TOUCH_ADDRESS,
  BOOKING_WIDGET_TOUCH_CITY,
  BOOKING_WIDGET_TOUCH_CONSENT,
  BOOKING_WIDGET_TOUCH_LOGIN_RETURNING_PATIENT,
  BOOKING_WIDGET_TOUCH_PATIENT_SEX,
  BOOKING_WIDGET_TOUCH_STATE,
  BOOKING_WIDGET_TOUCH_TELEMED_CONSENT,
  BOOKING_WIDGET_TOUCH_ZIP_CODE,
} from '../../../core/analytics/events';
import { analyticsTrackFormErrors } from '../../../core/analytics/index';
import { apiGetJsonBlocking } from '../../../core/dapi';
import { getPhoneNumberLookUpUrl } from '../../../core/dapi/phoneNumber';
import history from '../../../core/history';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
import withAuthentication from '../../../core/login/withAuthentication';
import {
  getActiveProfileFromState,
  getDisplayableUserProfilesInAccountSummary,
  getInsuranceProfileById,
  getProfileFromAccountSummary,
} from '../../../core/util/account';
import { isEmptyArray } from '../../../core/util/array';
import { isEmpty } from '../../../core/util/empty';
import { emptyFunction } from '../../../core/util/function';
import {
  isBirthSexRequired,
  isSelfPayOnly,
  isTelemedLocation,
  isBookingWidgetAddressRequired,
  isExternalTelemedLocation,
} from '../../../core/util/location';
import {
  convertSnakeToCamelCase,
  deleteUndefinedFields,
  isEmptyObject,
  safeGet,
} from '../../../core/util/object';
import { sanitizePhone } from '../../../core/util/phoneNumber';
import { getFieldObject } from '../../../core/util/rcForm/rcFormToReduxForm';
import { termsInputValidator, tosInputValidator } from '../../../core/util/rcForm/validators';
import { EN, SupportedLocale } from '../../../core/util/localizedStr';
import CheckboxInput from '../../Form/CheckboxInput';
import PatientSexSelectInput from '../../Form/PatientSexSelectInput';
import StateCodeSelectInput from '../../Form/StateCodeSelectInput';
import TextInput from '../../Form/TextInput';
import ConsentLabelBookingWidget, {
  BookingWidgetSMSConsentLabel,
  TeleMedConsentLabel,
} from '../../SolvPatternLibrary/Form/ConsentLabelBookingWidget';
import HowDoYouWantToPay from '../components/HowDoYouWantToPay';
import InsurancePricingFootnote from '../components/InsurancePricingFootnote';
import MainCta from '../components/MainCta';
import HomeAddress from '../components/PatientInfo/HomeAddress';
import TwilioModal, { TWILIO_MODAL_ID } from '../components/TwilioModal';
import { accountHasAddress, getAccountAddress, MOBILE } from '../util';
import {
  ADDRESS_FIELD_NAME,
  ADDRESS_SECONDARY_FIELD_NAME,
  BIRTH_DATE_FIELD_NAME,
  BIRTH_SEX_FIELD_NAME,
  CITY_FIELD_NAME,
  ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME,
  EMAIL_FIELD_NAME,
  FIRST_NAME_FIELD_NAME,
  getMobileSecondFormRequiredFields,
  IS_EXISTING_PATIENT_FIELD_NAME,
  LAST_NAME_FIELD_NAME,
  PAYMENT_FIELD_NAME,
  PHONE_FIELD_NAME,
  STATE_CODE_FIELD_NAME,
  TELEMED_CONSENT_FIELD_NAME,
  TOS_CONSENT_FIELD_NAME,
  UNDER_13_GUARDIAN_CONSENT_FIELD_NAME,
  ZIP_CODE_FIELD_NAME,
} from '../util/validators';
import UserInfoFromUserProfileFields from './components/UserProfileInfo/UserProfileFields';
import UserInfoFromUserProfileSelector from './components/UserProfileInfo/UserProfileSelector';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './MobileBookingWidgetSecondFor... Remove this comment to see the full error message
import s from './MobileBookingWidgetSecondForm.css';
import { TEST_PHONE_NUMBER } from '~/constants/phoneLoginForm';
import { getIsFamilyVisitActivatedInBookingWidget } from '~/ducks/bookingWidgetFamilyBooking';
import { AccountSummary } from '~/reducers/account';
import { Viewport } from '~/components/useViewport';

const StyledMainCta = styled(MainCta).withConfig({ componentId: 'sc-1k8agqa-0' })`
  margin-bottom: 30px;
  margin-top: 30px;
`;

const CheckboxesContainer = styled.div.withConfig({ componentId: 'sc-1k8agqa-1' })`
  margin: 0 20px;

  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const StyledUseAddressContainer = styled.div.withConfig({ componentId: 'sc-1k8agqa-2' })`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 24px;
`;

const StyledCheckbox = styled(Checkbox).withConfig({ componentId: 'sc-1k8agqa-3' })`
  padding: 0px 16px 0px 15px;
`;

const StyledUseAddressLabel = styled.label.withConfig({ componentId: 'sc-1k8agqa-4' })`
  font-family: 'Circular-Pro-Medium-S', sans-serif;
  color: ${colors.lanaDelGray};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;

const emptyInteractions = {
  onBlur: emptyFunction,
  onUpdate: emptyFunction,
  onFocus: emptyFunction,
};

type MobileBookingWidgetSecondFormProps = {
  form: formShape;
  allowLocationChange?: boolean;
  accountSummary?: any;
  userProfile?: any;
  newBooking?: any;
  location?: any;
  login?: any;
  setBookingProfile?: (accountSummary: AccountSummary, userProfileId: string) => void;
  viewport?: Viewport;
  submitting?: boolean;
  handleFormSubmit?: (...args: any[]) => any;
  setUserProfile?: (...args: any[]) => any;
  setInsuranceProfile?: (...args: any[]) => any;
  addUserProfileToNewBooking?: (...args: any[]) => any;
  addInsuranceProfileToNewBooking?: (...args: any[]) => any;
  insuranceProfile?: any;
  resetLogin?: (...args: any[]) => any;
  isModalOpen?: boolean;
  handleLogin?: (...args: any[]) => any;
  showModal?: (modalId: string) => void;
  npi?: any;
  initialValues?: any;
  isLoggedIn: boolean;
  locale?: SupportedLocale;
  t: TFunction<'common'>;
  setBookingProfilePending: (arg: boolean) => void;
  isFamilyVisit: boolean;
};

type MobileBookingWidgetSecondFormState = any;

class MobileBookingWidgetSecondForm extends Component<
  MobileBookingWidgetSecondFormProps,
  MobileBookingWidgetSecondFormState
> {
  static contextTypes = {
    setTitle: PropTypes.func.isRequired,
  };

  constructor(props: MobileBookingWidgetSecondFormProps) {
    super(props);
    this.state = {
      showUnderlay: false,
      focusedField: null,
      phoneFieldTouched: false,
      useAddress: false,
    };
  }

  componentDidMount() {
    if (
      this.props.isLoggedIn &&
      !isEmptyObject(this.props.userProfile) &&
      isEmptyObject(this.props.newBooking.booking.userProfile)
    ) {
      this.setUserProfile();
      this.setInsuranceProfile();
    }
  }

  onChangeOfUserProfile = (selectedUserProfile: any) => {
    if (selectedUserProfile.type === BookingProfileStatus.PENDING) {
      this.props.setBookingProfilePending(true);
    } else {
      this.props.setBookingProfilePending(false);
      const clickedUserProfileId = selectedUserProfile.value;

      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.setBookingProfile(this.props.accountSummary, clickedUserProfileId);
    }
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.addInsuranceProfileToNewBooking(this.props);
  };

  setInsuranceProfile = () => {
    if (
      !isEmptyObject(this.props.insuranceProfile) &&
      isEmptyObject(this.props.newBooking.insurance)
    ) {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.addInsuranceProfileToNewBooking(this.props);
    }
  };

  setUserProfile = () => {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.addUserProfileToNewBooking(this.props);
  };

  shouldShowUserProfileFields = () =>
    isEmptyArray(getDisplayableUserProfilesInAccountSummary(this.props.accountSummary));

  blurField = () => {
    this.setState({
      showUnderlay: false,
      focusedField: null,
    });
  };

  handleChangeUseAddress = (_: any, checked: any) => {
    this.setState({
      useAddress: checked,
    });
    if (checked) {
      const useAddress = getAccountAddress(this.props.accountSummary);
      this.props.form.setFieldsValue({
        [ADDRESS_FIELD_NAME]: useAddress.address,
        [ADDRESS_SECONDARY_FIELD_NAME]: useAddress.address_street_secondary,
        [CITY_FIELD_NAME]: useAddress.city,
        [STATE_CODE_FIELD_NAME]: useAddress.state,
        [ZIP_CODE_FIELD_NAME]: useAddress.zip_code,
      });
    }
  };

  validateField = () => {
    this.props.form.validateFields();
  };

  render() {
    const { t } = this.props;
    this.context.setTitle('Book Online - Confirm');
    const { submitting } = this.props;

    const firstName = getFieldObject(FIRST_NAME_FIELD_NAME, this.props, emptyInteractions);
    const lastName = getFieldObject(LAST_NAME_FIELD_NAME, this.props, emptyInteractions);
    const birthDate = getFieldObject(BIRTH_DATE_FIELD_NAME, this.props, emptyInteractions);
    const phone = getFieldObject(PHONE_FIELD_NAME, this.props, emptyInteractions);
    const email = getFieldObject(EMAIL_FIELD_NAME, this.props, emptyInteractions);
    const payment = getFieldObject(PAYMENT_FIELD_NAME, this.props, emptyInteractions);
    const tosConsent = getFieldObject(TOS_CONSENT_FIELD_NAME, this.props, emptyInteractions);
    const telemedConsent = getFieldObject(
      TELEMED_CONSENT_FIELD_NAME,
      this.props,
      emptyInteractions
    );
    const under13GuardianConsent = getFieldObject(
      UNDER_13_GUARDIAN_CONSENT_FIELD_NAME,
      this.props,
      emptyInteractions
    );
    const electronicCommunicationConsent = getFieldObject(
      ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME,
      this.props,
      emptyInteractions
    );
    const address = getFieldObject(ADDRESS_FIELD_NAME, this.props, emptyInteractions);
    const city = getFieldObject(CITY_FIELD_NAME, this.props, emptyInteractions);
    const stateCode = getFieldObject(STATE_CODE_FIELD_NAME, this.props, emptyInteractions);
    const zipCode = getFieldObject(ZIP_CODE_FIELD_NAME, this.props, emptyInteractions);
    const birthSex = getFieldObject(BIRTH_SEX_FIELD_NAME, this.props, emptyInteractions);
    const isExistingPatient = getFieldObject(
      IS_EXISTING_PATIENT_FIELD_NAME,
      this.props,
      emptyInteractions
    );

    const handleFormSubmit = (e: any, force: any) => {
      const { initialValues } = this.props;

      if (isEmpty(this.props.form.getFieldValue(PHONE_FIELD_NAME))) {
        this.props.form.setFieldsValue({
          phone: initialValues[PHONE_FIELD_NAME],
        });
      }

      if (isEmpty(this.props.form.getFieldValue(BIRTH_DATE_FIELD_NAME))) {
        this.props.form.setFieldsValue({
          birthDate: initialValues[BIRTH_DATE_FIELD_NAME],
        });
      }

      e && e.preventDefault();

      let form = this.props.form.getFieldsValue();
      let updatedForm = {};
      form = deleteUndefinedFields(form);
      form = { ...initialValues, ...form };
      if (typeof form.phone !== 'string') {
        updatedForm = {
          ...form,
          phone: isEmptyObject(form.phone) ? '' : form.phone.phone,
        };
      } else {
        updatedForm = { ...form };
      }

      if (!this.props.isModalOpen || force) {
        // Don't submit if modal is open
        this.setState({ submitted: true });
        this.props.form.validateFields(async (errors: any, values: any) => {
          if (!errors) {
            if (!force) {
              const phone = safeGet(values)('phone.phone');
              const twilioResponse = await apiGetJsonBlocking(getPhoneNumberLookUpUrl(phone));
              const isValidPhone = twilioResponse.status !== 404;

              if (!isValidPhone && phone !== TEST_PHONE_NUMBER) {
                // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
                this.props.showModal(TWILIO_MODAL_ID);
                return null;
              }
            }

            const trackingProperties = { locationId: this.props.location.id };
            analyticsTrackEvent(
              BOOKING_WIDGET_MOBILE_CLICK_CONTINUE_BUTTON_SECOND_FORM,
              trackingProperties
            );

            return this.props.handleFormSubmit?.(updatedForm, this.props);
          }

          analyticsTrackFormErrors(BOOKING_WIDGET_BOOK_FAIL, errors);
          return null;
        });
      }
    };

    const onMobilePhoneInputBlur = () => {
      this.setState({ phoneFieldTouched: true });
      this.validateField();
    };

    const handleReplaceInsurance = () => {
      history.push('add-insurance/bw');
    };

    const setZIndexGivenError = (field: any) => ({
      zIndex: field.invalid && field.touched ? 1 : 0,
    });

    const handleAndTrackLoginFromReturningPatientToggle = (e: any) => {
      // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.handleLogin(e);
      analyticsTrackEvent(BOOKING_WIDGET_TOUCH_LOGIN_RETURNING_PATIENT, {
        device: 'mobile',
      });
    };

    const getAddressFields = (placeholder: any) => (
      <div className={s.homeAddress} data-testid="mobileWidgetAddressFields">
        <div className={s.row} style={setZIndexGivenError(address)}>
          <div className={s.address}>
            <TextInput
              errorInline
              field={address}
              funPlaceholder
              id={ADDRESS_FIELD_NAME}
              inputProps={this.props.form.getFieldProps(ADDRESS_FIELD_NAME, {
                rules: [
                  {
                    required: getMobileSecondFormRequiredFields(
                      this.props.location,
                      this.props.form
                    ).includes(ADDRESS_FIELD_NAME),
                    message: 'required',
                  },
                ],
                initialValue: this.props.initialValues[ADDRESS_FIELD_NAME],
              })}
              placeholder={placeholder}
              placeholderContainerName={s.inputPlaceholder}
              s={s}
              showErrors={false}
              submitted={this.state.submitted}
              trackEvent={BOOKING_WIDGET_TOUCH_ADDRESS}
            />
          </div>
        </div>

        <div className={s.row} style={setZIndexGivenError(city)}>
          <div className={s.cityParts}>
            <div className={s.city}>
              <TextInput
                errorInline
                field={city}
                funPlaceholder
                id={CITY_FIELD_NAME}
                inputProps={this.props.form.getFieldProps(CITY_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(
                        this.props.location,
                        this.props.form
                      ).includes(CITY_FIELD_NAME),
                      message: 'required',
                    },
                  ],
                  initialValue: this.props.initialValues[CITY_FIELD_NAME],
                })}
                placeholder="City"
                placeholderContainerName={s.inputPlaceholder}
                s={s}
                showErrors={false}
                submitted={this.state.submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_CITY}
              />
            </div>

            <div className={s.stateCode}>
              <StateCodeSelectInput
                defaultValue="State"
                errorInline
                field={stateCode}
                funPlaceholder
                id={STATE_CODE_FIELD_NAME}
                inputProps={this.props.form.getFieldProps(STATE_CODE_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(
                        this.props.location,
                        this.props.form
                      ).includes(STATE_CODE_FIELD_NAME),
                      message: 'required',
                    },
                  ],
                  initialValue: this.props.initialValues[STATE_CODE_FIELD_NAME],
                })}
                onBlur={this.validateField}
                placeholder="State"
                s={s}
                showErrors={false}
                submitted={this.state.submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_STATE}
              />
            </div>

            <div className={s.zipCode}>
              <TextInput
                errorInline
                field={zipCode}
                funPlaceholder
                id={ZIP_CODE_FIELD_NAME}
                inputProps={this.props.form.getFieldProps(ZIP_CODE_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(
                        this.props.location,
                        this.props.form
                      ).includes(ZIP_CODE_FIELD_NAME),
                      message: 'required',
                    },
                  ],
                  initialValue: this.props.initialValues[ZIP_CODE_FIELD_NAME],
                  pattern: '[0-9]*',
                  inputMode: 'numeric',
                })}
                placeholder="ZIP code"
                placeholderContainerName={s.inputPlaceholder}
                s={s}
                showErrors={false}
                submitted={this.state.submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_ZIP_CODE}
              />
            </div>
          </div>
        </div>
      </div>
    );

    const locale = this.props.locale ?? EN;
    return (
      <div className={s.root}>
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '(e: any, force: any) => void' is not assigna... Remove this comment to see the full error message */}
        <form className={s.mobileBookingWidgetForm} onSubmit={handleFormSubmit}>
          <div
            className={this.state.showUnderlay ? s.underlayShown : s.underlayHidden}
            onClick={this.blurField}
          />

          <div
            className={this.state.showUnderlay ? s.underlayShown : s.underlayHidden}
            onClick={this.blurField}
          />

          <UserInfoFromUserProfileSelector
            accountSummary={this.props.accountSummary}
            form={this.props.form}
            getAddressFields={getAddressFields}
            handleReplaceInsurance={handleReplaceInsurance}
            initialValues={this.props.initialValues}
            insuranceProfile={this.props.insuranceProfile}
            isLoggedIn={this.props.isLoggedIn}
            location={this.props.location}
            onChangeOfUserProfile={this.onChangeOfUserProfile}
            payment={payment}
          />

          <UserInfoFromUserProfileFields
            accountSummary={this.props.accountSummary}
            birthDate={birthDate}
            birthSex={birthSex}
            email={email}
            firstName={firstName}
            form={this.props.form}
            getAddressFields={getAddressFields}
            handleAndTrackLoginFromReturningPatientToggle={
              handleAndTrackLoginFromReturningPatientToggle
            }
            initialValues={this.props.initialValues}
            isExistingPatient={isExistingPatient}
            isLoggedIn={this.props.isLoggedIn}
            lastName={lastName}
            location={this.props.location}
            newProfilePending={this.props.newBooking.bookingProfilePending}
            onMobilePhoneInputBlur={onMobilePhoneInputBlur}
            phone={phone}
            phoneFieldTouched={this.state.phoneFieldTouched}
            setZIndexGivenError={setZIndexGivenError}
            submitted={this.state.submitted}
          />

          {!this.shouldShowUserProfileFields() &&
            isBirthSexRequired(this.props.location) &&
            !this.props.newBooking.bookingProfilePending && (
              <div className={s.loggedInPatientSexField}>
                <PatientSexSelectInput
                  errorInLine
                  field={birthSex}
                  funPlaceholder
                  id={BIRTH_SEX_FIELD_NAME}
                  inputProps={this.props.form.getFieldProps(BIRTH_SEX_FIELD_NAME, {
                    rules: [
                      {
                        required: getMobileSecondFormRequiredFields(
                          this.props.location,
                          this.props.form
                        ).includes(BIRTH_SEX_FIELD_NAME),
                      },
                    ],
                    initialValue: this.props.initialValues[BIRTH_SEX_FIELD_NAME],
                  })}
                  placeholder={t('userInfo.patientSex.capitalize')}
                  s={s}
                  showErrors={false}
                  submitted={this.state.submitted}
                  trackEvent={BOOKING_WIDGET_TOUCH_PATIENT_SEX}
                  validateField={this.validateField}
                />
              </div>
            )}

          {this.props.newBooking.bookingProfilePending &&
            isBookingWidgetAddressRequired(this.props.location) &&
            accountHasAddress(this.props.accountSummary) && (
              <StyledUseAddressContainer>
                <StyledCheckbox
                  checked={this.state.useAddress}
                  onChange={this.handleChangeUseAddress}
                  size="small"
                />
                <StyledUseAddressLabel>{t('addressSameAsAccount')}</StyledUseAddressLabel>
              </StyledUseAddressContainer>
            )}

          <HomeAddress
            form={this.props.form}
            initialValues={this.props.initialValues}
            locale={locale}
            location={this.props.location}
            setZIndexGivenError={setZIndexGivenError}
            submitted={this.state.submitted}
            validateField={this.validateField}
            version={MOBILE}
          />
          {!this.props.isFamilyVisit && (
            <>
              <HowDoYouWantToPay
                form={this.props.form}
                initialValues={this.props.initialValues}
                location={this.props.location}
                payment={payment}
              />

              <InsurancePricingFootnote location={this.props.location} />

              <CheckboxesContainer>
                <CheckboxInput
                  field={tosConsent}
                  id={TOS_CONSENT_FIELD_NAME}
                  inputProps={this.props.form.getFieldProps(TOS_CONSENT_FIELD_NAME, {
                    rules: [
                      {
                        required: getMobileSecondFormRequiredFields(
                          this.props.location,
                          this.props.form
                        ).includes(TOS_CONSENT_FIELD_NAME),
                        validator: tosInputValidator,
                      },
                    ],
                    initialValue: this.props.initialValues[TOS_CONSENT_FIELD_NAME],
                  })}
                  label={<ConsentLabelBookingWidget />}
                  submitted={this.state.submitted}
                  trackEvent={BOOKING_WIDGET_TOUCH_CONSENT}
                />
                <CheckboxInput
                  field={electronicCommunicationConsent}
                  id={ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME}
                  inputProps={this.props.form.getFieldProps(
                    ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME,
                    {
                      rules: [
                        {
                          required: getMobileSecondFormRequiredFields(
                            this.props.location,
                            this.props.form
                          ).includes(ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME),
                          validator: termsInputValidator,
                        },
                      ],
                      initialValue:
                        this.props.initialValues[ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME],
                    }
                  )}
                  label={<BookingWidgetSMSConsentLabel />}
                  submitted={this.state.submitted}
                  trackEvent={BOOKING_WIDGET_ELECTRONIC_COMMUNICATION_CONSENT_FIELD_NAME}
                />

                {isTelemedLocation(this.props.location) &&
                  !isExternalTelemedLocation(this.props.location) && (
                    <CheckboxInput
                      field={telemedConsent}
                      id={TELEMED_CONSENT_FIELD_NAME}
                      inputProps={this.props.form.getFieldProps(TELEMED_CONSENT_FIELD_NAME, {
                        rules: [
                          {
                            required: getMobileSecondFormRequiredFields(
                              this.props.location,
                              this.props.form
                            ).includes(TELEMED_CONSENT_FIELD_NAME),
                            validator: termsInputValidator,
                          },
                        ],
                        initialValue: this.props.initialValues[TELEMED_CONSENT_FIELD_NAME],
                      })}
                      label={<TeleMedConsentLabel />}
                      submitted={this.state.submitted}
                      trackEvent={BOOKING_WIDGET_TOUCH_TELEMED_CONSENT}
                    />
                  )}
              </CheckboxesContainer>
            </>
          )}

          <StyledMainCta
            appointmentType={safeGet(this.props)('newBooking.booking.appointmentType')}
            isModalOpen={this.props.isModalOpen}
            npiSubmitting={safeGet(this.props)('npi.submitting')}
            submitting={submitting}
          />
        </form>

        <TwilioModal reSubmitBooking={handleFormSubmit} />
      </div>
    );
  }
}

const isAnyModalOpen = (state: any) => {
  let status = false;

  if (isEmptyObject(state.runtime.modal)) {
    return false;
  }

  if (state.runtime.modal.loginModal) {
    status = state.runtime.modal.loginModal;
  }

  if (state.runtime.modal.insuranceModal) {
    status = state.runtime.modal.insuranceModal;
  }

  return status;
};

const mapStateToProps = (state: any) => {
  const accountSummary = state.account.summary;
  const userProfile = getActiveProfileFromState(state);
  const insuranceProfile =
    !isEmptyObject(accountSummary) && !isEmptyObject(userProfile)
      ? getInsuranceProfileById(accountSummary.insurance_profiles, userProfile.insurance_profile_id)
      : null;
  const { newBooking } = state;

  return {
    initialValues: {
      firstName: newBooking.profile.firstName,
      lastName: newBooking.profile.lastName,
      birthDate: newBooking.profile.birthDate,
      // eslint-disable-next-line no-nested-ternary
      phone: newBooking.profile.phone
        ? { phone: sanitizePhone(newBooking.profile.phone) }
        : newBooking.bookingProfilePending && accountSummary?.phone
        ? { phone: sanitizePhone(accountSummary?.phone) }
        : '',
      email: newBooking.profile.email,
      payment: isSelfPayOnly(state.location) ? TYPE_SELF : TYPE_INSURANCE,
      insuranceProfile,
      isExistingPatient: false,
      address_street: newBooking.profile.address_street,
      address_city: newBooking.profile.address_city,
      address_state: newBooking.profile.address_state,
      address_zip: newBooking.profile.address_zip,
    },
    viewport: state.runtime.viewport,
    login: state.login,
    newBooking,
    userProfile,
    insuranceProfile,
    isModalOpen: isAnyModalOpen(state),
    account:
      !isEmptyObject(state.login) && !isEmptyObject(state.login.account) ? state.login.account : {},
    npi: state.npi,
    isFamilyVisit: getIsFamilyVisitActivatedInBookingWidget(state),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  addInsuranceProfileToNewBooking: (props: any) => {
    const { insuranceProfile } = props;
    dispatch(
      insuranceFormSubmission({
        ...convertSnakeToCamelCase(insuranceProfile),
      })
    );
  },

  addUserProfileToNewBooking: (props: any) => {
    dispatch(
      profileFormSubmission({
        ...convertSnakeToCamelCase(props.userProfile),
        phone: props.login.account.phone,
        email: props.login.account.email,
      })
    );
  },

  setBookingProfile: (accountSummary: AccountSummary, userProfileId: string) => {
    const userProfile = getProfileFromAccountSummary(accountSummary, userProfileId);
    dispatch(receiveUserProfileForNewBooking(userProfile));
    dispatch(
      profileFormSubmission({
        ...convertSnakeToCamelCase(userProfile),
        phone: accountSummary.phone,
        email: accountSummary.email,
      })
    );
  },

  showModal: (modalId: string) => dispatch(showModal(modalId)),
});

const ConnectedMobileBookingWidgetSecondForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileBookingWidgetSecondForm);

export default withStyles(s)(
  withTranslation()(withAuthentication(createForm()(ConnectedMobileBookingWidgetSecondForm)))
);
